import { ButtonBase, ClickAwayListener } from "@mui/material";
import React, { useState } from "react";
import { inputButtonStyle } from "../input/inputWrapper";
import {
  DISPLAY,
  JUSTIFY_CONTENT,
  SPACING,
  TEXT_ALIGN,
} from "../../Constants/Enums/styles.enum";
import { Colors } from "../../Constants/colors";
import { DropdownAnchor } from "./DropdownAnchor";

interface IDropdownWrapperProps {
  children({
    isDropdownClicked,
    setDropdownClicked,
  }: {
    isDropdownClicked: boolean;
    setDropdownClicked: (dropDownClicked: boolean) => unknown;
  }): React.ReactNode;
  onClick?: (cb: () => unknown) => unknown;
}

export const DropdownWrapper = ({
  children,
  onClick,
}: IDropdownWrapperProps) => {
  const [dropdownClicked, setDropdownClicked] = useState<boolean>(false);

  const handleDropdownCloseAction = () => {
    setDropdownClicked(!dropdownClicked);
  };

  const handleDropdownClick = () => {
    if (onClick) {
      return onClick(handleDropdownCloseAction);
    }
    // in future all the action should be handled inside  handleDropdownCloseAction as it might be used as callback function
    handleDropdownCloseAction();
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        setDropdownClicked(false); // Close the dropdown when clicked away
      }}
    >
      <ButtonBase
        style={{
          ...inputButtonStyle,
          height: "auto",
          display: DISPLAY.FLEX,
          justifyContent: JUSTIFY_CONTENT.START,
          textAlign: TEXT_ALIGN.LEFT,
          width: "100%",
          gap: SPACING.S10,
        }}
        onClick={handleDropdownClick}
      >
        <div style={{ flex: 1 }}>
          {children({ isDropdownClicked: dropdownClicked, setDropdownClicked })}
        </div>

        <div
          style={{
            border: `1px solid ${Colors.LightAshRose}`,
            height: "100%",
            borderRadius: "4px",
          }}
        />

        <DropdownAnchor
          onClick={() => {
            setDropdownClicked(!dropdownClicked);
          }}
          isClicked={dropdownClicked}
        />
      </ButtonBase>
    </ClickAwayListener>
  );
};
